import React from 'react';
import style from './style.scss';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {openPopupProductDetail} from 'actions';
import {ShowIf} from 'components/utils';
import {SendRequestButton} from 'components/partials/send-request-button';
import {ShoppingCartButton} from 'components/partials/shopping-cart-button';
import {getPrice} from 'lib/convert';

class Product extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      time: ''
    }
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    if(this.props.SystemInfo && this.props.SystemInfo.endDate) {
      this.countDown(this.props.SystemInfo.endDate)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.SystemInfo !== this.props.SystemInfo && this.props.SystemInfo.endDate) {
      this.countDown(this.props.SystemInfo.endDate)
    }
  }

  onClick(e) {
    if (typeof this.props.onClick == 'undefined') {
      this.props.dispatch(openPopupProductDetail(this.props.id));
    } else {
      this.props.onClick(e);
    }
  }

  onClickButtonEditProduct() {
    this.props.onClickButtonEditFairProduct();
  }

  countDown(endTime) {
    if (endTime && this.wrap) {
      var dateEntered = new Date(endTime);
      var now = new Date();
      var difference = dateEntered.getTime() - now.getTime();

      if (difference <= 0) {
        return
      } else {

        var seconds = Math.floor(difference / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours %= 24;
        minutes %= 60;
        seconds %= 60;
        let self = this;
        setTimeout(function() {
          self.countDown(endTime);
        }, 1000)
        this.setState({
          time: `Còn ${days + ' ngày ' + (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)}`
        })
      }
    }
  }

  render() {
    const {averageRatingPoint, totalRatingTimes, promotionalPrice, price, isOnlyApplyPromotionalPriceFair} = this.props;
    // the final price will be equal to promotionalPrice or price of the product
    const finalPrice = promotionalPrice || price;
    // the price and promotionalPrice are numbers, the promitionPrice is smaller than the price
    const isHasDifferencePrice = typeof getPrice(price, null) === 'number' &&
      typeof getPrice(promotionalPrice, null) === 'number' &&
      getPrice(price, null) - getPrice(promotionalPrice, null) > 0;
    // check condition to show countdown
    const isShowCountdown = isOnlyApplyPromotionalPriceFair && isHasDifferencePrice;
    return (
      <div className="product" ref={(wrap) => this.wrap = wrap}>
        <div className="wrap-img" onClick={this.onClick}>
          <UploadImage type="PRODUCT" width="177" height="127" transform="crop" image={this.props.images[this.props.images.length -1]} />
        </div>
        <div className={this.props.fixHeightContent ? 'product-wrap-detail' : ''}>
          <p className="name">
            <span className="product-link" onClick={this.onClick}><span className="name-link">{this.props.name}</span></span>
          </p>
          <ShowIf condition={typeof getPrice(finalPrice, null) === 'number' && getPrice(finalPrice, null) > 0}>
            <p className="price">GIÁ: {getPrice(finalPrice)}</p>
          </ShowIf>
          <ShowIf condition={typeof getPrice(finalPrice, null) !== 'number'}>
            <p className="price">GIÁ: Giá tham khảo</p>
          </ShowIf>
          <ShowIf condition={isHasDifferencePrice}>
            <p className="price-old"><span className='price-throught'>{getPrice(this.props.price)}</span></p>
          </ShowIf>
          <p className="description">{this.props.description}</p>
          <ShowIf condition={totalRatingTimes > 0}>
            <div className='rating-result'>
              <div className="rating-value" style={{width: averageRatingPoint && averageRatingPoint.toFixed(1) * 20}}></div>
              <img src={require('assets/images/rating/result.png')} alt="rating" />
              <span className='rating-count'>({totalRatingTimes})</span>
            </div>
          </ShowIf>
        </div>
        <p className='text-count-down'>{isShowCountdown ? this.state.time : ''}</p>
        <ShowIf condition={typeof getPrice(finalPrice, null) === 'number' && getPrice(finalPrice, null) > 0}>
          <ShoppingCartButton productId={this.props.id} isDetail={false} />
        </ShowIf>
        <ShowIf condition={typeof getPrice(finalPrice, null) !== 'number'}>
          <SendRequestButton productId={this.props.id} />
        </ShowIf>
      </div>
    );
  }
}

Product.propTypes = {
  showDescription: PropTypes.bool,
  enableAddProduct: PropTypes.bool,
  showPrice: PropTypes.bool,
  showSalePrice: PropTypes.bool,
  showFairSalePrice: PropTypes.bool,
  showEditButton: PropTypes.bool,
  fairProduct: PropTypes.bool,
  showStatus: PropTypes.bool,
  fixHeightContent: PropTypes.bool
};

Product.defaultProps = {
  showDescription: true,
  enableAddProduct: false,
  showPrice: true,
  showFairSalePrice: false,
  fixHeightContent: true,
  showSalePrice: false,
  showEditButton: false,
  fairProduct: false,
  showStatus: false
};

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};


export default connect(bindStateToProps)(Product);



// WEBPACK FOOTER //
// ./components/partials/product/Product.jsx